import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import TenantForm, { TenantStatus, TenantTypes } from './TenantForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import tenantService from './tenantService';

const TenantEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [entity, setEntity] = useState<any>({
    id: '',
    name: '',
    slug: '',
    type: TenantTypes.Organization,
    status: TenantStatus.Active,
    contactName: '',
    contactEmail: '',
    region: '',
    defaultLanguage: 'hu',
    timeZone: 'Europe/Budapest',
  });
  const { canPlatform } = useCheckPermission();

  useEffect(() => {
    tenantService.get(params.id).then((response: any) => {
      if (response.hasError) {
        setErrors(response.errorMessages ?? []);
        enqueueSnackbar((response.errorMessages ?? []).join(','), {
          variant: 'error',
        });
      } else {
        setEntity(response.result);
      }
    });
  }, [params.id]);

  const onSubmit = (values: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    tenantService
      .update(values)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', { variant: 'success' });
          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <TenantForm
      entity={entity}
      readonly={!canPlatform(['ManageTenants'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
    />
  );
};

export default TenantEdit;
